import { atom } from 'recoil'
import { ANALYSIS_ATOM_KEYS } from './keys'
import { AirbridgeHelper } from 'core/airbridge'
import { MarketingGTMHelper } from 'core/marketingGTM'

export const STORE_AIRBRIDGE = atom<AirbridgeHelper>({
  key: ANALYSIS_ATOM_KEYS.STORE_AIRBRIDGE,
  default: undefined,
})

export const STORE_MARKETING_GTM = atom<MarketingGTMHelper>({
  key: ANALYSIS_ATOM_KEYS.STORE_MARKETING_GTM,
  default: undefined,
})
